/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Gl_LeadInputs */

const en_mk_tut_gl_lead = /** @type {(inputs: Mk_Tut_Gl_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The terms used across the product, explained once, here.`)
};

const id_mk_tut_gl_lead = /** @type {(inputs: Mk_Tut_Gl_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istilah yang dipakai di seluruh produk, dijelaskan sekali di sini.`)
};

/**
* | output |
* | --- |
* | "The terms used across the product, explained once, here." |
*
* @param {Mk_Tut_Gl_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_gl_lead = /** @type {((inputs?: Mk_Tut_Gl_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Gl_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_gl_lead(inputs)
	return en_mk_tut_gl_lead(inputs)
});